import axios from 'axios';
import { attachSentryInterceptor } from './sentryInterceptor';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
});

attachSentryInterceptor(api);

export default api;
